"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ActionButton = _interopRequireDefault(require("./ActionButton"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const minHeight = '80px';
const slideIn = (0, _styledComponents.keyframes)(["from{transform:translateY(", ");opacity:0;}to{transform:translateY(0px);opacity:1;}"], minHeight);
const slideOut = (0, _styledComponents.keyframes)(["from{transform:translateY(0px);opacity:1;}to{transform:translateY(", ");opacity:0;}"], minHeight);

const BottomSheet = _styledComponents.default.div.withConfig({
  displayName: "BottomSheet"
})(["position:", ";bottom:", ";left:0;right:0;display:flex;min-height:", ";background-color:white;box-shadow:0 0 12px ", ";animation:", " 0.4s;"], ({
  visible
}) => visible ? 'fixed' : 'none', ({
  bottom
}) => "".concat(bottom, "px"), minHeight, ({
  theme: {
    palette
  }
}) => palette.border, ({
  visible
}) => visible ? slideIn : slideOut);

BottomSheet.ActionButton = _ActionButton.default;
BottomSheet.propTypes = {
  bottom: _propTypes.default.number.isRequired,
  visible: _propTypes.default.bool.isRequired
};
var _default = BottomSheet;
exports.default = _default;